import { storeToRefs } from 'pinia';

const useAnalyticsIdentify = () => {
  const userStore = useUserStore();
  const { user, inPersonification } = storeToRefs(userStore);
  const regionStore = useRegionStore();

  const { data: ipData } = useFetch<{ ip: string }>('/api/ip');
  const { setUserProperties } = useTracker();

  const getPersistentReferrer = (): string => {
    if (
      typeof window === 'undefined' ||
      typeof sessionStorage === 'undefined'
    ) {
      return '';
    }

    const STORAGE_KEY = 'analytics_initial_referrer';

    const storedReferrer = sessionStorage.getItem(STORAGE_KEY);
    if (storedReferrer) {
      return storedReferrer;
    }

    const currentReferrer = document.referrer || 'direto (sem referrer)';

    sessionStorage.setItem(STORAGE_KEY, currentReferrer);

    return currentReferrer;
  };

  watch(
    () => [
      user.value,
      inPersonification.value,
      ipData.value?.ip,
      regionStore.region,
    ],
    ([newUser, inPersonification, ipData, region]) => {
      if (newUser) {
        const realUser = userStore.user;
        const realUserId = realUser?.id || 0;

        const partnerId = userStore.partnerId || 0;

        const originalReferrer = getPersistentReferrer();

        const userPayload = {
          user_id: realUserId,
          region,
          partner_id: partnerId,
          is_personification: inPersonification,
          ip_address: ipData,
          page_referrer: originalReferrer,
        };

        if (userPayload) {
          setUserProperties({
            ...userPayload,
          });
        }
      }
    },
    {
      immediate: true,
    },
  );
};

export default useAnalyticsIdentify;
